import { Input } from 'antd';
import React from 'react';
import FormItem from 'components/FormItem';
import patterns from 'utils/patterns';

export interface EmailProps {
    name: string;
    label?: React.ReactNode;
    placeholder?: string;
    disabled?: boolean;
    disabledValidate?: boolean; // 取消
    line?: boolean; // 底部单线框模式
    size?: 'large' | 'middle' | 'small';
    className?: string;
}

const Email: React.FC<EmailProps> = ({
    name = 'email',
    label,
    placeholder = __('Email Address'),
    disabled,
    disabledValidate,
    size,
    line,
    className
}) => {
    const $validators = {
        isEmail: (value, prop, { validMessage: { isEmail } }) => disabledValidate || patterns.isEmail(value) || isEmail,
        isError: () => true
    };

    return (
        <FormItem
            className={className}
            label={label}
            name={name}
            $validators={$validators}
            isEmail
            isError
            line={line}
            required={!disabled}
            validMessage={{
                required: __('Please enter your email address'),
                isEmail: __('The email address you entered is not valid')
            }}>
            <Input placeholder={placeholder} size={size} disabled={disabled} />
        </FormItem>
    );
};

export default Email;
